export default __webpack_public_path__ + "static/media/Group 10400.ed07338a.svg";